module.exports = __webpack_public_path__ + "static/media/pkglist_item1.cff9466b.jpg";